export default __webpack_public_path__ + "empty-search-md.e1a55bfa.svg";